import { createContext, useContext, useReducer } from "react";
// import faker from "faker";
import { cartReducer, productReducer } from "./Reducers";
import productsArray from '../MOCK_DATA.json';

const Cart = createContext();
// faker.seed(99);

const Context = ({ children }) => {

  const products = productsArray.map(({id,name,price,image, inStock, fastDelivery,ratings}) => ({
    id ,
    name,
    price,
    image,
    inStock,
    fastDelivery,
    ratings,
  }));

   console.log(products.id);

  const [state, dispatch] = useReducer(cartReducer, {
    products: products,
    cart: [],
  });

  const [productState, productDispatch] = useReducer(productReducer, {
    byStock: false,
    byFastDelivery: false,
    byRating: 0,
    searchQuery: "",
  });

  console.log(productState);

  return (
    <Cart.Provider value={{ state, dispatch, productState, productDispatch }}>
      {children}
    </Cart.Provider>
  );
};

export const CartState = () => {
  return useContext(Cart);
};

export default Context;
